var url = {
    isTest: process.env.NODE_ENV === 'development',
    getHost: function () {
        if (this.isTest)
            return 'localhost:5000';
        return 'fin.jnqianle.cn';
    },
    getDomain: function () {
        if(this.isTest)
        return `http://${this.getHost()}`;
        return `https://${this.getHost()}`;
    },
    getController: function (str) {
        return `${this.getDomain()}/${str}`;
    },
    //UE服务端接口
    getUE: function () {
        return this.getController('api/ueditor');
    },
    //UE配置地址
    getUEConfig: function () {
        if (this.isTest)
            return '/UEditor/';
        return '/vue/UEditor/';
    },
    //统一上传地址
    getUpload: function () {
        if (this.isTest)
            return "ws://" + this.getHost() + "/upload/common";
        return "wss://" + this.getHost() + "/upload/common";
    },
    getCompany: function (str) {
        var controller = this.getController('company');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getAccount(str) {
        var controller = this.getController('account');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getCategory(str) {
        var controller = this.getController('categoryinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getSubject(str) {
        var controller = this.getController('subjectinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getCards(str) {
        var controller = this.getController('cardsinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getAccInfo(str) {
        var controller = this.getController('accinfo');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getBaseData(str) {
        var controller = this.getController('basedata');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getProject(str) {
        var controller = this.getController('project');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getUser(str) {
        var controller = this.getController('user');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getFin(str) {
        var controller = this.getController('fin');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getCrm(str) {
        var controller = this.getController('crm');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getAtt(str) {
        var controller = this.getController('Att');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getCommon(str) {
        var controller = this.getController('common');
        if (str)
            controller += '/' + str;
        return controller;
    },
    getArt(str) {
        return this.getController('api/art', str);
    },
    getCdn(str) {
        var controller = this.getController('cdn');
        if (str)
            controller += '/' + str;
        return controller;
    },
}
export default url;